module.exports = global["eventBus"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./index.js");